import React from "react"

export const DarkSearch = props => (
  <svg
    width="21px"
    height="19px"
    viewBox="0 0 21 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Search</title>
    <desc />
    <g
      id="Desktop-+-Mobile"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="A12_Desktop-Roster-List"
        transform="translate(-1304.000000, -29.000000)"
        stroke="#000000"
      >
        <g id="Navigation" transform="translate(696.000000, 29.000000)">
          <g id="Search/Black" transform="translate(609.000000, 1.000000)">
            <g id="Search">
              <path
                d="M16,8 C16,12.418107 12.418107,16 8,16 C3.581893,16 0,12.418107 0,8 C0,3.581893 3.581893,0 8,0 C12.418107,0 16,3.581893 16,8 Z"
                id="Stroke-1"
              />
              <path d="M14,13 L19,18" id="Stroke-3" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
